import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './stores/index'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入所有图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


import "normalize.css"
import "./assets/css/index.css"
import { i18n } from './i18n'


// 创建应用实例
const app = createApp(App)

// 全局注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 安装插件
app
  .use(router)
  .use(pinia)
  .use(i18n)
  .use(ElementPlus)
  .mount('#app')
